import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { useSelector } from 'react-redux';

const Crumbs = ({ crumbs }) => {

    const authData = useSelector(s => s.auth.data);
    const [crumbsData, setCrumbsData] = useState([...crumbs]);

    useEffect(() => {
        let temp = [...crumbsData];
        if (authData && authData.id && temp[0].label != "Home") {
            temp.unshift({
                path: "/portal/",
                label: "Home",
                active: false,
            });
            temp = temp.filter(val => val != "");
            setCrumbsData([...temp]);
        }
    }, [crumbsData]);

    return (
        <nav aria-label="breadcrumb" className="mb-3">
            <Breadcrumbs
                separator={<span style={{ color: '#94A3B8', fontSize: '0.85rem' }}>/</span>}
                aria-label="breadcrumb"
            >
                {crumbsData.map((crumb, index) => (
                    <Link
                        key={index}
                        to={crumb.path || ""}
                        style={{
                            color: crumb.active ? "#0F172A" : "#B11116",
                            fontWeight: crumb.active ? 600 : 500,
                            fontSize: "0.85rem",
                            textDecoration: "none",
                            pointerEvents: crumb.path && !crumb.active ? "auto" : "none",
                            transition: "color 0.15s ease",
                        }}
                        onMouseEnter={(e) => {
                            if (!crumb.active && crumb.path) e.currentTarget.style.textDecoration = "underline";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.textDecoration = "none";
                        }}
                    >
                        {crumb.label}
                    </Link>
                ))}
            </Breadcrumbs>
        </nav>
    );
}

export default Crumbs;